import { inject } from '@angular/core';
import { SubmissionStatusesSignalState } from '../store';

export const submissionStatusesResolver = () => {
  const _submissionStatusesSignalState = inject(SubmissionStatusesSignalState);

  if (!_submissionStatusesSignalState.$submissionStatuses()) {
    _submissionStatusesSignalState.getSubmissionStatuses();
  }
  return (
    !!_submissionStatusesSignalState.$submissionStatuses() &&
    !_submissionStatusesSignalState.$isLoading()
  );
};
